/**
 * Preorder UI updater
 *
 * Reads the per-product JSON data island (data-preorder-data) and updates the ATC
 * button label, badge, and hidden line-item-property inputs whenever the active
 * variant changes.
 *
 * Variant changes are detected by watching the [data-current-variant-json] textarea
 * (Motion theme's own variant-state mechanism) for mutations. Falls back to listening
 * for native change events on [data-product-select] and any input[name="id"] within
 * the form.
 */
(function () {
  'use strict';

  function init(form) {
    if (!form || form.dataset.preorderInit === '1') return;

    // Use getAttribute('id'): a hidden input named "id" inside this form (Shopify's
    // variant input) shadows form.id and returns the element instead of the attribute.
    var formIdAttr = form.getAttribute('id');
    if (!formIdAttr) return;

    var dataEl = document.querySelector('script[data-preorder-data][data-form-id="' + formIdAttr + '"]');
    if (!dataEl) return;

    form.dataset.preorderInit = '1';

    var preorderMap;
    try {
      preorderMap = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var atcText = form.querySelector('[data-add-to-cart-text]');
    var atcButton = form.querySelector('[data-add-to-cart]');
    var badge = form.querySelector('[data-preorder-badge]');
    var propVisible = form.querySelector('input[name="properties[preorder]"]');
    var propHidden = form.querySelector('input[name="properties[_preorder_ship_date]"]');
    var propPlan = form.querySelector('input[name="selling_plan"][data-preorder-selling-plan]');
    var variantSelect = form.querySelector('[data-product-select]');
    var variantJsonEl = form.querySelector('[data-current-variant-json]');
    var estDelivery = form.querySelector('[data-est-delivery]');

    function activeVariantId() {
      // Prefer the form's <select name="id"> — it's what Shopify uses on submit and
      // is updated immediately by every variant-change path (radios, swatches, URL).
      if (variantSelect && variantSelect.value && /^\d+$/.test(variantSelect.value)) {
        return String(variantSelect.value);
      }
      if (variantJsonEl) {
        try {
          var v = JSON.parse(variantJsonEl.value);
          if (v && v.id) return String(v.id);
        } catch (e) {}
      }
      var hidden = form.querySelector('input[name="id"]:not([type="hidden"][data-product-select])');
      if (hidden && hidden.value && /^\d+$/.test(hidden.value)) return String(hidden.value);
      return null;
    }

    function applyState() {
      var id = activeVariantId();
      var state = id && preorderMap[id];
      var active = !!(state && state.active);

      if (atcText) {
        if (active) {
          atcText.textContent = state.button_label;
        } else {
          var def = atcText.getAttribute('data-default-text');
          if (def && atcText.textContent !== def) atcText.textContent = def;
        }
      }

      if (badge) {
        if (active) {
          badge.textContent = state.message;
          badge.hidden = false;
        } else {
          badge.hidden = true;
          badge.textContent = '';
        }
      }

      if (propVisible) {
        propVisible.value = active ? state.property_value : '';
        propVisible.disabled = !active; // disabled inputs don't submit
      }
      if (propHidden) {
        propHidden.value = active ? state.ship_date : '';
        propHidden.disabled = !active;
      }
      if (propPlan) {
        var planId = active && state.selling_plan_id ? String(state.selling_plan_id) : '';
        propPlan.value = planId;
        propPlan.disabled = !planId;
      }

      if (atcButton) {
        atcButton.classList.toggle('is-preorder', active);
      }

      // Hide the "fastest 3-day delivery" promise on preorder variants — it's
      // false when the item ships on a future preorder date. Re-shown when the
      // shopper switches back to an in-stock (non-preorder) variant.
      if (estDelivery) {
        estDelivery.hidden = active;
      }
    }

    // Initial paint
    applyState();

    // Watch the variant JSON textarea (Motion updates this on variant change)
    if (variantJsonEl && 'MutationObserver' in window) {
      new MutationObserver(applyState).observe(variantJsonEl, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    // Fallbacks
    if (variantSelect) variantSelect.addEventListener('change', applyState);
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t && (t.name === 'id' || (t.name && t.name.indexOf('option') === 0))) applyState();
    });
  }

  function bootstrap() {
    document.querySelectorAll('form.product-single__form').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  // Re-init on any future product form (quick view, ajax PDP loads)
  if ('MutationObserver' in document) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('form.product-single__form')) init(n);
          if (n.querySelectorAll) n.querySelectorAll('form.product-single__form').forEach(init);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
